import { render, staticRenderFns } from "./NavigationButton.vue?vue&type=template&id=5c99475c&scoped=true&"
import script from "./NavigationButton.vue?vue&type=script&lang=ts&"
export * from "./NavigationButton.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationButton.vue?vue&type=style&index=0&id=5c99475c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c99475c",
  null
  
)

export default component.exports